import React, { useEffect, useState } from "react";
import { Wifi, WifiOff } from "@mui/icons-material";
import { IconButton } from "@mhome/ui";

const Online1Widget = ({ widget, onValueUpdate }) => {
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      if (widget.items.$w1.value === "online") {
        setIsOnline(true);
      } else {
        setIsOnline(false);
      }
    }
    return () => {};
  }, [widget]);

  return (
    <div className="w-full h-full flex items-center cursor-pointer">
      <div className="h-full aspect-square flex items-center justify-center">
        <IconButton
          className="w-full h-full p-1 hover:bg-transparent"
          style={{
            backgroundColor: isOnline
              ? "rgba(76, 175, 80, 0.1)"
              : "rgba(244, 67, 54, 0.1)",
          }}
        >
          {isOnline ? (
            <Wifi
              style={{
                width: "100%",
                height: "100%",
                color: "#4CAF50",
              }}
            />
          ) : (
            <WifiOff
              style={{
                width: "100%",
                height: "100%",
                color: "#F44336",
              }}
            />
          )}
        </IconButton>
      </div>
    </div>
  );
};

export default Online1Widget;
